import { NavigationNode } from '~/lib/data-contract';
import { NavigationItem } from '../navigation-item/navigation-item.component';
import styles from './item-list.module.css';
import { clsx } from 'clsx';

type Props = {
    items: NavigationNode[];
    onMenuClick?: (item: NavigationNode | null) => void;
    onNavigationClick?: () => void;
    isSubList?: boolean;
    selectedItem?: NavigationNode | null;
};

const ItemList = ({ items, onMenuClick, isSubList, selectedItem, onNavigationClick }: Props) => {
    return (
        <ul
            className={clsx(styles.root, {
                [styles.subList]: isSubList,
                [styles.columns]: items.length > 10,
            })}
        >
            {items.map((item, index) => {
                const isActive = selectedItem?.id === item.id;
                return (
                    <li key={`${item.id}-${index}`} className={styles.item}>
                        <NavigationItem
                            item={item}
                            isActive={isActive}
                            onMenuClick={() => {
                                isActive ? onMenuClick?.(null) : onMenuClick?.(item);
                            }}
                            onNavigationClick={() => onNavigationClick?.()}
                            isSubItem={isSubList}
                        />
                    </li>
                );
            })}
        </ul>
    );
};

export default ItemList;
